export const environment = {
  production: true,
  loadingUtag: true,
  api: {
    tile: 'https://assistance.orange-business.com/contact-us/api/contact-tree',
  },
  lpEnv: 'prod',
  djingoScriptUrl: 'https://espaceclientpro.orange.fr/djingo/assets/integration/djingoChatProd.js',
  djingoCallerId: 'ENT_NC_WEB',
  authorizedFirstSegmentUrl: [
    {
      firstSegmentUrl: '',
      authorizedBusinessSegment: '',
    },
    {
      firstSegmentUrl: 'public',
      authorizedBusinessSegment: '',
    },
    {
      firstSegmentUrl: 'pme',
      authorizedBusinessSegment: 'EN',
    },
    {
      firstSegmentUrl: 'propme',
      authorizedBusinessSegment: 'P',
    },
    {
      firstSegmentUrl: 'gc',
      authorizedBusinessSegment: 'GC',
    },
  ],
  authorizedUsers: [
    {
      email: 'remy.oger@orange.com',
      firstName: 'demo',
      lastName: 'propme',
      segCommercial: 'P',
    },
  ],
  authorizedSirens: [
    {
      siren: '380129866',
      segCommercial: 'GC',
    },
    {
      siren: '827475864',
      segCommercial: 'GC',
    },
  ],
  unauthorizedErrorUrl: '/error/unauthorized',
  notFoundErrorUrl: '/error/notfound',
  publicUrl: '/public',
  navbarScriptUrl: 'https://espace-client.orange-business.com/web/navbar/bundle.js',
  urlEchatNewtonByECE: 'https://espace-client.orange-business.com/api/ece/echats/',
  tracking: true,
};
